import { render, staticRenderFns } from "./aed-openingHours.vue?vue&type=template&id=6a24285b&"
import script from "./aed-openingHours.vue?vue&type=script&lang=js&"
export * from "./aed-openingHours.vue?vue&type=script&lang=js&"
import style0 from "./aed-openingHours.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports